import type { ComponentProps } from 'react';
import Animated, { FadeInDown, FadeOutDown } from 'react-native-reanimated';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import useTimer from '@/hooks/useTimer';
import Box from '../UI/Box';
import Icon from '../Unistyles/Icon';

export function useButtonToast() {
  return useTimer<ComponentProps<typeof ButtonToast>>({
    text: '',
    variant: 'white',
    icon: null,
  });
}

export default function ButtonToast({
  text,
  icon,
  variant = 'black',
}: {
  text: string | null;
  icon: ComponentProps<typeof Icon>['name'] | null;
  variant: ComponentProps<typeof Box>['background'];
}) {
  return text ? (
    <Animated.View
      entering={FadeInDown.damping(10).duration(200)}
      exiting={FadeOutDown.damping(10).duration(200)}
      style={style.container}
    >
      <Box
        background={variant}
        direction="horizontal"
        space="sm"
        style={style.innerContainer}
      >
        {icon ? <Icon variant="white" name={icon} /> : null}
        <Text size="lg" variant="white">
          {text}
        </Text>
      </Box>
    </Animated.View>
  ) : null;
}

const style = StyleSheet.create((theme) => ({
  container: {
    position: 'absolute',
    bottom: theme.size(16),
    width: '100%',
    alignItems: 'center',
  },
  innerContainer: {
    padding: theme.size(3),
    borderRadius: theme.borderRadius.full,
    overflow: 'hidden',
  },
}));
